"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Checkbox = _interopRequireDefault(require("../Forms/Checkbox"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _formItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/form-item.css") : void 0);

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _formItem.default), _list.default));

var ListSelection = function ListSelection(_ref) {
  var checkBoxAriaLabel = _ref.checkBoxAriaLabel,
      className = _ref.className,
      children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      _onChange = _ref.onChange,
      selected = _ref.selected,
      props = (0, _objectWithoutProperties2.default)(_ref, ["checkBoxAriaLabel", "className", "children", "cssNamespace", "onChange", "selected"]);

  var _useState = (0, _react.useState)(selected || false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedState = _useState2[0],
      setSelectedState = _useState2[1];

  var ListSelectionClasses = classnames("".concat(cssNamespace, "-form-item"), "".concat(cssNamespace, "-list__form-item"), className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: ListSelectionClasses
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    ariaLabel: checkBoxAriaLabel,
    checked: selectedState,
    inline: true,
    onChange: function onChange(e, checked) {
      setSelectedState(checked);

      _onChange(e, checked);
    }
  })), children);
};

ListSelection.displayName = 'List.Selection';
process.env.NODE_ENV !== "production" ? ListSelection.propTypes = {
  /** aria-label for the checkbox */
  checkBoxAriaLabel: _propTypes.default.string.isRequired,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Boolean value controlled by parent List.Item*/
  selected: _propTypes.default.bool,

  /**
   * Callback function; triggered when the change event fires on the underlying HTML checkbox `<input>`
   * of the parent `<li>`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Boolean} checkedState - represents the final checked state of the HTML checkbox input.
   * @returns {void}
  */
  onChange: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(ListSelection);

exports.default = _default;